import { render, staticRenderFns } from "./InquiryList.vue?vue&type=template&id=6692604a&"
import script from "./InquiryList.vue?vue&type=script&lang=ts&"
export * from "./InquiryList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports